"use strict";

$(window).scroll(function () {
  if ($(document).scrollTop() > 50) {
    $('#white-navbar').addClass('shrink');
    $('.main-right-column').addClass('shrink');
    $('.main-left-column').addClass('shrink');
    $("a[href='#top']").addClass('color-secondary');
    $("a[href='#top']").removeClass('color-grey');
  } else {
    $('#white-navbar').removeClass('shrink');
    $('.main-left-column').removeClass('shrink');
    $('.main-right-column').removeClass('shrink');
    $("a[href='#top']").addClass('color-grey');
    $("a[href='#top']").removeClass('color-secondary');
  }
});
$("a[href='#top']").click(function () {
  $("html, body").animate({
    scrollTop: 0
  }, "slow");
  return false;
});
$("#more-details-btn").click(function (e) {
  e.preventDefault();
  $("#masthead-search-form").toggleClass('show-more');
  $(".masthead").toggleClass('show-more');
});
$(".terms-checkbox").click(function () {
  $(".container-radio:hover .checkmark").toggleClass('checked');
});
$("#more-details-listing-btn").click(function (e) {
  e.preventDefault(); $(".form-search-house-home-listing").toggleClass('show-more');
});
$("#more-details-listing-btn-2").click(function (e) {
  e.preventDefault(); $(".form-search-house-home-listing").toggleClass('show-more');
}); // $("#show-more-properties").click(function () {
// reloadPropertiesMap();
// });

$("#find-properties").click(function () {
  loadEstatesForMap(reloadPropertiesMap);
});

export function openNav() {
  document.getElementById("overlay-menu").style.height = "100%";
  setTimeout(function () {
    $('#navbar-sub-footer').show();
  }, 300);
}

export function closeNav() {
  document.getElementById("overlay-menu").style.height = "0%";
  $('#navbar-sub-footer').hide();
}

// $(document).on('click', ".listing-property-estate", function (e) {
//   console.log('clicked on property ' + jQuery(this).attr("id"));
//   setCookie("idEstate", jQuery(this).attr("id"), 5);
// });

function setCookie(cname, cvalue, minutes) {
  var expiryDate = new Date();
  expiryDate.setMonth(expiryDate.getMonth() + 1);
  var expires = 'expires=' + expiryDate.toGMTString();
  document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}

function getCookie(cname) {
  var name = cname + "=";
  var decodedCookie = decodeURIComponent(document.cookie);
  var ca = decodedCookie.split(';');

  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];

    while (c.charAt(0) == ' ') {
      c = c.substring(1);
    }

    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }

  return "";
}

export var waitForEl = function waitForEl(selector, callback) {
  if (jQuery(selector).length) {
    callback();
  } else {
    setTimeout(function () {
      waitForEl(selector, callback);
    }, 100);
  }
};

function loadEstatesForMap(functionForLoadingPins) {

  // console.log("CITY : "+ $("#city").val());
  $.post(ajaxurl, {
    'action': 'get_estate_address_list',
    'toSell': $("#toSell").prop("checked") ? 1 : null,
    'toRent': $("#toRent").prop("checked") ? 2 : null,
    'homeType': $("#homeType").val() ? $("#homeType").val() : null,
    'zip' : $("[name='Zip']").val() ? $("[name='Zip']").val() : null,
    // 'city': $("[name='ef-zip-search']").val() ? $("[name='ef-zip-search']").val() : null,
    'bedroomNumber': $("#bedroomNumber").val() ? $("#bedroomNumber").val() : null,
    'minPrice': $("[name='MinPrice']").val() ? $("[name='MinPrice']").val() : null,
    'maxPrice': $("[name='MaxPrice']").val() ? $("[name='MaxPrice']").val() : null,
    'bathroomNumber': $("#bathroomNumber").val() ? $("#bathroomNumber").val() : null,
    'areaMin': $("[name='AreaMin']").val() ? $("[name='AreaMin']").val() : null,
    'areaMax': $("[name='AreaMax']").val() ? $("[name='AreaMax']").val() : null,
    'garden': $("[name='Garden']").prop("checked") ? 1 : null,
    'terrace': $("[name='Terrace']").prop("checked") ? 1 : null,
    'parking': $("[name='Parking']").prop("checked") ? 1 : null,
    'garage': $("[name='Garage']").prop("checked") ? 1 : null
  }, function (json) {
    // console.log(json);
    var html = createHTMLEstatesForMap(json);
    $(".hidden-property-data").remove();
    $("#efFilterID").append(html);
    functionForLoadingPins();
  }, 'json');
}

function createHTMLEstatesForMap(estates) {
  var html = '';

  // console.log("Estate :");
  // console.log(estates);

  for (var estateId in estates) {
    html += "<div data-adress=\"".concat(estates[estateId].address, "\" \n                data-url=\"").concat(estates[estateId].url, "\"\n                data-banner=\"").concat(estates[estateId].banner, "\"\n                data-picture=\"").concat(estates[estateId].picture, "\"\n                data-title=\"").concat(estates[estateId].title, "\"\n                data-latitude=\"").concat(estates[estateId].latitude, "\"\n                data-longitude=\"").concat(estates[estateId].longitude, "\"';\n                data-price=\"").concat(estates[estateId].price, "\"\n                data-area=\"").concat(estates[estateId].area, " m\xB2\"\n                data-rooms=\"").concat(estates[estateId].rooms, "\"\n                data-bathrooms=\"").concat(estates[estateId].bathrooms, "\"");

    if (estates[estateId].energy) {
      html += "data-energy=\"".concat(estates[estateId].energy, "\"");
    }

    html += "class=\"hidden-property-data\"></div>";
  }

  return html;
}

$(document).ready(function () {
  initListingGoogleMapBehavior();
  initCheckbox();

  if ($('.ef-estateListing').length) {
    loadEstatesForMap(initSearchResultsMap);
  }

  AOS.init({
    duration: 1200
  });
  $('#showcase-listing').slick({
    slidesToShow: 4,
    slidesToScroll: 4,
    autoplay: true,
    autoplaySpeed: 2000,
    arrows: false,
    dots: false,
    pauseOnHover: true,
    responsive: [{
      breakpoint: 1199.98,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2
      }
    }, {
      breakpoint: 520,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }]
  });
});

function initListingGoogleMapBehavior() {
  if ($(".googlemap-container").length) {
    $(window).on("resize", function () {
      var parentWidth = $(".googlemap-container").parent().width();
      $(".googlemap-container").css("width", parentWidth + "px");
    });
    $(window).resize();
  }
}

function initCheckbox() {
  $(".ef-input-checkbox").each(function () {
    var el = this;
    $("input", this).prop("checked", false);
    $("input", this).on("click", function () {
      $("label", el).toggleClass("active");
    });
  });
}

var searchResultsMap = null;
var searchResultsMarkers = [];
var pinBlueURL = '/app/themes/sogefim/assets/img/Pin_Blue.png';
var pinDoreURL = '/app/themes/sogefim/assets/img/Pin_Dore.png';
var sogefimIconURL = '/app/themes/sogefim/assets/img/Pin_Sogefim.png';

export function initMap() {
  if (document.getElementById('map') !== null) {
    initMainMap();
  }

  if (document.getElementById('search-results-map') !== null && jQuery(".page-template-page-bien").length) {
    initSearchResultsMap();
  }

}

function initMainMap() {
  var map = createMap(document.getElementById('map'), mapCenterSogefim, mapStyleSogefim);
  createMarker(map, sogefimIconURL, map.getCenter(), google.maps.Animation.DROP, '');
}

function createMap(HTMLElement, mapCenter, mapStyle) {
  return new google.maps.Map(HTMLElement, {
    zoom: 15,
    center: mapCenter,
    styles: mapStyle,
    disableDefaultUI: true
  });
}

function reloadPropertiesMap() {
  setTimeout(function () {
    deleteMarkers(searchResultsMap, searchResultsMarkers);
    initSearchResultsMap();
  }, 0);
}

function setMapOnAll(markers) {
  for (var i = 0; i < markers.length; i++) {
    markers[i].setMap(null);
  }
}

function clearMarkers(markers) {
  setMapOnAll(markers);
}

function deleteMarkers(markers) {
  clearMarkers(markers);
  searchResultsMarkers = [];
}

function createMarker(map, iconURL, position, animation, labelContent) {
  var marker;
  if(labelContent != '') {
    marker = new google.maps.Marker({
      map: map,
      icon:  {
        url : iconURL,
        labelOrigin: new google.maps.Point(12, 46),
      },
      position: position,
      animation: animation,
      label: {
        color: '#0E1E33',
        fontWeight: 'bold',
        text: labelContent,
      },
    });
  } else {
    marker = new google.maps.Marker({
      map: map,
      icon:  {
        url : iconURL,
      },
      position: position,
      animation: animation,      
    });
  }

  return marker;
}

function findLatLang(address, geocoder) {
  return new Promise(function (resolve, reject) {
    geocoder.geocode({
      'address': address
    }, function (results, status) {
      if (status === 'OK') {
        resolve(results);
      } else {
        reject(new Error('Couldnt\'t find the location ' + address));
      }
    });
  });
}

function getPoints(geocoder, addressData) {
  var locationData = [];
  var latValue;

  for (var i = 0; i < addressData.length; i++) {
    locationData.push(findLatLang(addressData[i].dataset.adress, geocoder));
  }

  return locationData;
}

function addHTMLToMarker(address, marker) {
  var energyHTML = '';
  var id = Math.floor(Math.random() * Math.floor(99999));
  
  var biens = address['biens'];
  var markerContentHTML = '<div id="carouselExampleIndicators--' + id +'" class="carousel slide googlemap-slick" data-ride="carousel">';
  for(var i=0 ; i<biens.length ; i++) {

    if (biens[i].dataset.energy) {
      energyHTML = '<img class="peb-logo" src="' + biens[i].dataset.energy + '"></img>';
    }

    let url = biens[i].dataset.url,
    html = '<div class="listing-showcase-main-img" style="background-image: url(\'' + biens[i].dataset.picture + '\');"><div class="listing-showcase-option">' + biens[i].dataset.banner + '</div></div><div class="listing-showcase-content"><h3 class="listing-showcase-title">' + biens[i].dataset.title + '</h3>' + energyHTML + '<h5 class="listing-showcase-subtitle">' + biens[i].dataset.adress + '</h5><p class="price">' + biens[i].dataset.price + '</p><div class="listing-showcase-item-footer"><i class="far fa-square"></i><span>' + biens[i].dataset.area + '</span><i class="fas fa-bed"></i><span>' + biens[i].dataset.rooms + '</span><i class="fas fa-bath"></i><span>' + biens[i].dataset.bathrooms + '</span></div></div>',
    c = ((url != ''))
    ? '<a class="property clickable" href="' + biens[i].dataset.url + '">' + html + '</a>'
    : '<div class="property">' + html + '</div>';

    markerContentHTML += c;
  }
  
  markerContentHTML += '</div>';

  // var infowindow = new google.maps.InfoWindow({content : markerContentHTML});
  var infowindow = new google.maps.InfoWindow({content : ''});

  google.maps.event.addListener(marker, 'click', function () {
    infowindow.setContent(markerContentHTML)
    infowindow.open(map, marker);    
  });

  google.maps.event.addListener(infowindow,"domready", function() {
    $("#carouselExampleIndicators--" + id).slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 2000,
      arrows: true,
      dots: false,
      pauseOnHover: true,        
    });
  });
}

function getAddresses() {
  // console.log(document.getElementsByClassName("hidden-property-data"));
  var biens = document.getElementsByClassName("hidden-property-data");

  var addresses = {};

  // Regroupement des biens par coordonnées GPS
  for(var i=0 ; i<biens.length ; i++) {
    // console.log(biens[i]);

    var gpsKey = biens[i].dataset.latitude.replace('.','') + biens[i].dataset.longitude.replace('.','');
    if(!(addresses[gpsKey])) {
      addresses[gpsKey] = {};
    }
    addresses[gpsKey]['id']        = "map-estate-"+i;
    addresses[gpsKey]['latitude']  = biens[i].dataset.latitude;
    addresses[gpsKey]['longitude'] = biens[i].dataset.longitude;

    if(!(addresses[gpsKey]['biens'])) {
      addresses[gpsKey]['biens'] = [];
    }
    addresses[gpsKey]['biens'].push(biens[i]);
  }

  // return document.getElementsByClassName("hidden-property-data");

  // console.log(addresses);
  return addresses;
}

function getFirstPropertyID(addresses) {
  var propertyID = null;

  if (Object.keys(addresses)[0]) {
    propertyID = addresses[Object.keys(addresses)[0]].id;
  }

  return propertyID;
}

function getGeocodedAddresses(addresses) {
  var geocoder = new google.maps.Geocoder();
  return getPoints(geocoder, addresses);
}

function createMarkersOnMapAndResize(locations, map, propertyID, addresses, mapCenter) {
  // var locationsValues = locations;
  var bounds = new google.maps.LatLngBounds();

  for (var key in addresses) {
    var position = new google.maps.LatLng(parseFloat(addresses[key].latitude), parseFloat(addresses[key].longitude))

    var nbrBiens = '';
    if(addresses[key].biens.length > 1) {
      nbrBiens = String(addresses[key].biens.length);
    }
    var marker = createMarker(map, pinBlueURL, position, google.maps.Animation.DROP, nbrBiens);
    searchResultsMarkers.push(marker);
    addHTMLToMarker(addresses[key], marker);    

    bounds.extend(position);
  }

  var location = window.location.pathname;
  var parts = location.split('/');

  // bounds.extend(mapCenter);
  if(propertyID) {

    map.setCenter(bounds.getCenter());
    map.setZoom(8);

    console.log(parts.length);
    if(parts.length <= 3) setTimeout(function () { map.fitBounds(bounds); }, 1000);
    else map.setZoom(14);


    // setTimeout(function () {
    //   map.fitBounds(bounds);

    //   // if(propertyID) {
    //   //   map.setZoom(12);
    //   // }
    // }, 1000);
  }
  else {
    map.setZoom(9);
  }
}

function initSearchResultsMap() {
  var addresses = getAddresses();
  // console.log(addresses);
  
  var propertyID = getFirstPropertyID(addresses);
  var HTMLElement = document.getElementById('search-results-map');
  searchResultsMap = createMap(HTMLElement, mapCenterSogefim, mapStyleSogefim);

  // alert(propertyID)
  if (!propertyID) {} // createMarker(searchResultsMap, sogefimIconURL, searchResultsMap.getCenter(), google.maps.Animation.DROP);
  // var locations = getGeocodedAddresses(addresses);

  var locations = [];

  // for (var i = 0; i < addresses.length; i++) {
  //   locations.push(new google.maps.LatLng(parseFloat(addresses[i].latitude), parseFloat(addresses[i].longitude)));
  // }

  createMarkersOnMapAndResize(locations, searchResultsMap, propertyID, addresses, mapCenterSogefim);
}

function msieversion() {
  var ua = window.navigator.userAgent;
  var msie = ua.indexOf("MSIE ");

  if (msie > 0 || !!navigator.userAgent.match(/Trident.*rv\:11\./)) {
    return true;
  } else {
    return false;
  }

  return false;
}

var mapCenterSogefim = {
  lat: 50.6420624,
  lng: 5.5724115
};
var mapStyleSogefim = [{
  "elementType": "geometry",
  "stylers": [{
    "color": "#f5f5f5"
  }]
}, {
  "elementType": "labels.icon",
  "stylers": [{
    "visibility": "off"
  }]
}, {
  "elementType": "labels.text.fill",
  "stylers": [{
    "color": "#616161"
  }]
}, {
  "elementType": "labels.text.stroke",
  "stylers": [{
    "color": "#f5f5f5"
  }]
}, {
  "featureType": "administrative.land_parcel",
  "elementType": "labels.text.fill",
  "stylers": [{
    "color": "#bdbdbd"
  }]
}, {
  "featureType": "poi",
  "elementType": "geometry",
  "stylers": [{
    "color": "#eeeeee"
  }]
}, {
  "featureType": "poi",
  "elementType": "labels.text.fill",
  "stylers": [{
    "color": "#757575"
  }]
}, {
  "featureType": "poi.park",
  "elementType": "geometry",
  "stylers": [{
    "color": "#e5e5e5"
  }]
}, {
  "featureType": "poi.park",
  "elementType": "labels.text.fill",
  "stylers": [{
    "color": "#9e9e9e"
  }]
}, {
  "featureType": "road",
  "elementType": "geometry",
  "stylers": [{
    "color": "#ffffff"
  }]
}, {
  "featureType": "road.arterial",
  "elementType": "labels.text.fill",
  "stylers": [{
    "color": "#757575"
  }]
}, {
  "featureType": "road.highway",
  "elementType": "geometry",
  "stylers": [{
    "color": "#dadada"
  }]
}, {
  "featureType": "road.highway",
  "elementType": "labels.text.fill",
  "stylers": [{
    "color": "#616161"
  }]
}, {
  "featureType": "road.local",
  "elementType": "labels.text.fill",
  "stylers": [{
    "color": "#9e9e9e"
  }]
}, {
  "featureType": "transit.line",
  "elementType": "geometry",
  "stylers": [{
    "color": "#e5e5e5"
  }]
}, {
  "featureType": "transit.station",
  "elementType": "geometry",
  "stylers": [{
    "color": "#eeeeee"
  }]
}, {
  "featureType": "water",
  "elementType": "geometry",
  "stylers": [{
    "color": "#c9c9c9"
  }]
}, {
  "featureType": "water",
  "elementType": "labels.text.fill",
  "stylers": [{
    "color": "#9e9e9e"
  }]
}];